export enum AddressPermissions {
  UPDATE_ADDRESS = 'address.update',
  CREATE_ADDRESS = 'address.create',
}
